<template>
    <div :class="$style.page_toggles">
        <div :class="$style.page_buttons">
            <template
                v-for="(item, index) in visiblePageItems"
                :key="`${item}-${index}`"
            >
                <Button
                    size="m"
                    :to="getPageLink(item.page)"
                    :interfaceTarget="`click-page-${item.page}`"
                    :label="item.label"
                    :color="props.currentPage === item.page ? 'purple-400-flat' : 'carbon-400'"
                />
            </template>
        </div>
        <div :class="$style.navigation_buttons">
            <IconButton
                :class="[$style.navigation_button_override, props.currentPage <= 1 ? $style.disabled_override : '']"
                color="carbon-400"
                size="m"
                icon="chevron-left"
                :interfaceTarget="`click-page-${prevPage}`"
                :to="getPageLink(prevPage)"
            />
            <IconButton
                :class="[
                    $style.navigation_button_override,
                    props.currentPage >= props.totalPages ? $style.disabled_override : '',
                ]"
                color="carbon-400"
                size="m"
                :interfaceTarget="`click-page-${nextPage}`"
                icon="chevron-right"
                :to="getPageLink(nextPage)"
            />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import { RouteLocationRaw } from 'vue-router'

import Button from '@/components/Buttons/Button.vue'
import IconButton from '@/components/Buttons/IconButton.vue'

import { getVisiblePageItems } from './get-visible-pages'

const props = withDefaults(
    defineProps<{
        totalPages?: number
        currentPage?: number
        getPageLink: (page: number) => RouteLocationRaw
    }>(),
    {
        totalPages: 5,
        currentPage: 1,
    },
)

const prevPage = computed<number>(() => props.currentPage - 1)
const nextPage = computed<number>(() => props.currentPage + 1)
const visiblePageItems = computed(() => getVisiblePageItems(props.currentPage, props.totalPages))
</script>
<style module>
.page_toggles {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 16px 0;
}

.page_buttons,
.navigation_buttons {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 6px;
}

.navigation_buttons {
    width: 100%;
}

.navigation_button_override {
    flex: 1;
}

.disabled_override {
    color: var(--white-20);
    --main: var(--carbon-400);
    pointer-events: none;
}

@media (--desktop-small-plus) {
    .page_toggles {
        gap: 18px;
        padding: 8px 0;
    }

    .navigation_buttons {
        width: auto;
    }

    .navigation_button_override {
        flex: none;
    }
}
</style>
